import useTranslation from '../../hooks/useTranslation';
import { useEffect, useRef } from 'react';

import useSelectField from 'hooks/useSelectField';

import type { FieldValues, Props } from './types';

const useData = <T extends FieldValues>({
    control,
    farmId,
    isOpen,
    isRequired = false,
    name,
    onPanelClose,
    onPanelOpen,
    ref
}: Props<T>) => {
    const prevFarmIdRef = useRef<string | undefined>(farmId ?? undefined);
    const { FIELD_IS_REQUIRED } = useTranslation();

    const selectField = useSelectField({
        control,
        isOpen,
        isRequired,
        name,
        onPanelClose,
        onPanelOpen,
        ref,
        requiredMessage: isRequired ? FIELD_IS_REQUIRED : false
    });

    const { onChange } = selectField;

    useEffect(() => {
        const prevFarmId = prevFarmIdRef.current;

        // Must be null rather than undefined: react-hook-form treats undefined as "unset" and
        // useWatch then falls back to the form's default value, which resurrects the field the
        // farm change was supposed to clear.
        if (prevFarmId !== undefined && farmId !== prevFarmId) {
            onChange(null);
        }

        prevFarmIdRef.current = farmId ?? undefined;
    }, [farmId, onChange]);

    return selectField;
};

export default useData;
